// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"338":"060787d11cea7316","6901":"9a0b033e75a7dbfa","8863":"3b4fcaf1e79b4059"}[chunkId] + ".css";
};